<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/home" @click="updateListCategory('listCategoryHome')">Home</b-breadcrumb-item>
      <b-breadcrumb-item href="#planned" active>Planned</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="template-name">Planned</h1>
    <p>Planned tasks. No surprise.</p>
    <b-tabs content-class="mt-3" active-nav-item-class="font-weight-bold">
      <b-tab title="Personal List" active>
        <div class="task-container">
          <div v-if="showPlaceholderImagePersonal && !hideWhenInitialLoadPersonal" class="no-task-container">
            <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
                   alt="No task picture"></b-img>
            <h2>No planned task</h2>
            <p>Plan ahead by setting the due date on your task</p>
          </div>
          <regular-with-origin-task-cell v-else v-for="plannedTask in personalPlannedTaskDocuments"
                                         :key="plannedTask.taskId"
                                         :task-details="plannedTask"></regular-with-origin-task-cell>
        </div>
      </b-tab>
      <b-tab title="Collaborative List">
        <div class="task-container">
          <div v-if="showPlaceholderImageCollaborative && !hideWhenInitialLoadCollaborative" class="no-task-container">
            <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
                   alt="No task picture"></b-img>
            <h2>No planned task</h2>
            <p>Plan ahead by setting the due date on your task</p>
          </div>
          <regular-with-origin-task-cell v-for="plannedTask in collaborativePlannedTaskDocuments"
                                         :key="plannedTask.taskId"
                                         :task-details="plannedTask"></regular-with-origin-task-cell>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import RegularWithOriginTaskCell from "../table_cells/task_cells/RegularWithOriginTaskCell"
import {mapActions, mapGetters} from "vuex";
import firebase from "firebase";
import {db} from "../../main";

export default {
  data() {
    return {
      showPlaceholderImagePersonal: null,
      showPlaceholderImageCollaborative: null,
      hideWhenInitialLoadPersonal: true,
      hideWhenInitialLoadCollaborative: true,
      personalPlannedTaskDocuments: null,
      collaborativePlannedTaskDocuments: null
    }
  },
  components: {
    regularWithOriginTaskCell: RegularWithOriginTaskCell
  },
  methods: {
    ...mapActions([
      "updateListCategory"
    ]),
    getPlannedTaskData() {
      const date = new Date()
      date.setDate(date.getDate() + 1)
      date.setHours(0, 0, 0, 0)

      const currentDate = firebase.firestore.Timestamp.fromDate(date)

      this.$bind(
          'personalPlannedTaskDocuments',
          db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Personal Task')
              .where('dueDate', '>=', currentDate)
              .where('completed', '==', false)
              .orderBy('dueDate', 'asc')
      ).then(() => {
        if (this.personalPlannedTaskDocuments.length === 0) {
          this.showPlaceholderImagePersonal = true
        }
        this.hideWhenInitialLoadPersonal = false
      })

      this.$bind(
          'collaborativePlannedTaskDocuments',
          db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Collaborative Task')
              .where('dueDate', '>=', currentDate)
              .where('completed', '==', false)
              .orderBy('dueDate', 'asc')
      ).then(() => {
        if (this.collaborativePlannedTaskDocuments.length === 0) {
          this.showPlaceholderImageCollaborative = true
        }
        this.hideWhenInitialLoadCollaborative = false
      })
    }
  },
  watch: {
    personalPlannedTaskDocuments(newProperties, oldProperties) {
      this.showPlaceholderImagePersonal = this.personalPlannedTaskDocuments.length === 0
    },
    collaborativePlannedTaskDocuments(newProperties, oldProperties) {
      this.showPlaceholderImageCollaborative = this.collaborativePlannedTaskDocuments.length === 0
    }
  },
  mounted() {
    this.getPlannedTaskData()
  }
}
</script>

<style scoped>
.no-task-container {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.no-task-picture {
  width: 375px;
  margin-bottom: 1em;
}

.template-name {
  font-size: 2em;
  margin-bottom: 0.5em;
}

.task-container {
  height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}
</style>
